import "./WebsiteForTradespeople.module.css";
import Header from "@/reusable_sections/Header";
import FindingHomeInYourNeighborhood from "./sections/FindingHomeInYourNeighborhood";
import RoleOverviewResponsibilities from "./sections/RoleOverviewResponsibilities";
import EngineAnimation from "./sections/EngineAnimation";
import BranchenFeatures from "./sections/BranchenFeatures";
import BeispielMockup from "./sections/BeispielMockup";
import ChooseYourPathToHarmony from "./sections/ChooseYourPathToHarmony";
import ClientTestimonials from "./sections/ClientTestimonials";
import BeginYourExperience from "./sections/BeginYourExperience";
import Footer from "@/reusable_sections/Footer";
export default function WebsiteForTradespeoplePage() {
  return <div>
      <Header />
      <FindingHomeInYourNeighborhood />
      <RoleOverviewResponsibilities />
      <EngineAnimation />
      <BranchenFeatures />
      <BeispielMockup />
      <ChooseYourPathToHarmony />
      <ClientTestimonials />
      <BeginYourExperience />
      <Footer />
    </div>;
}